import { useState, useEffect } from 'react';
import { VideoMetadata } from '../services/api';

interface HistoryItem extends VideoMetadata {
  timestamp: number;
}

const HISTORY_KEY = 'video_download_history';
const MAX_HISTORY_ITEMS = 50;

export const useDownloadHistory = () => {
  const [history, setHistory] = useState<HistoryItem[]>([]);

  useEffect(() => {
    // Load history from localStorage on mount
    const savedHistory = localStorage.getItem(HISTORY_KEY);
    if (savedHistory) {
      try {
        setHistory(JSON.parse(savedHistory));
      } catch (error) {
        console.error('Failed to parse download history:', error);
        localStorage.removeItem(HISTORY_KEY);
      }
    }
  }, []);

  const addToHistory = (videoInfo: VideoMetadata) => {
    const newItem: HistoryItem = {
      ...videoInfo,
      timestamp: Date.now()
    };

    setHistory(prevHistory => {
      // Remove duplicates and add new item at the start
      const filteredHistory = prevHistory.filter(item => item.url !== videoInfo.url);
      const newHistory = [newItem, ...filteredHistory].slice(0, MAX_HISTORY_ITEMS);
      
      // Save to localStorage
      localStorage.setItem(HISTORY_KEY, JSON.stringify(newHistory));
      
      return newHistory;
    });
  };

  const clearHistory = () => {
    setHistory([]);
    localStorage.removeItem(HISTORY_KEY);
  };

  const deleteItem = (videoInfo: VideoMetadata) => {
    setHistory(prevHistory => {
      const newHistory = prevHistory.filter(item => item.url !== videoInfo.url);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(newHistory));
      return newHistory;
    });
  };

  return {
    history,
    addToHistory,
    clearHistory,
    deleteItem
  };
}; 